export enum HighlightsType {
    AcceptsRefunds = 'accepts_refunds',
    AgeRestriction = 'age_restriction',
    Duration = 'duration',
    ETicket = 'eticket',
    FreeParking = 'free_parking',
    Parking = 'parking',
}

export type HighlightsProps = {
    [key: string]: boolean | string | HighlightDurationValue | undefined;
    accepts_refunds?: boolean;
    parking?: boolean;
    duration?: HighlightDurationValue;
    age_restriction?: string;
};

export type HighlightDurationValue = {
    totalSeconds: number;
    days: number;
    hours: number;
    minutes: number;
};
